import React, { Component } from 'react';
import { DatePicker, message, Select, Table } from 'antd';
import moment from 'moment-timezone';
import { map } from 'lodash';
import * as yup from 'yup';

import Loader from '../../../Common/Component/Loader';
import DataTable from './Datatable';
import {errorHandle} from "../../../Common/errorHandle";

const { Option } = Select;

class FranchiseAlerts extends Component {

  state = {
    all_alerts: [],
    alert_pagination: { current: 1, showSizeChanger: false, pageSize: 10, ordering: "", },
    alerts: [
      { key: 'hurricane', value: 'Hurricane' },
      { key: 'snow_day', value: 'Snow Day' },
      { key: 'no_service', value: 'No Service' },
      { key: 'strom', value: 'Storm' },
      { key: 'promotion', value: 'Promotion' },
    ],
    new_alert: {
      alert_type: '',
      start_date: '',
      end_date: '',
      alert_desccription: '',
      untill_further_notice: false,
    },
    delete_id: '',
    isNav: '',
    is_edit: false,
    openNav: false,
    loader: false,
    field_office_uuid: '',
    is_add_user_Active: false
  }
  componentDidMount = () => {
    if (this.props.history.location.state) {
      this.setState({
        field_office_uuid: this.props.history.location.state.query.data.uuid,
        loader: true
      })
      this.props.getFieldAlert(
        {
          field_office__uuid: this.props.history.location.state.query.data.uuid,
          limit: 10,
          offset: 0
        }
      );
    }
  }

  UNSAFE_componentWillReceiveProps = (props) => {
    let { alert_pagination } = this.state;
    // message.destroy();

    //Add new Alerts
    if (Object.keys(props.NewFieldAlert.data).length > 0 && props.NewFieldAlert.data !== this.props.NewFieldAlert.data) {
      this.setState({
        loader: false
      })

      this.setState({
        new_alert: {
          alert_type: '',
          start_date: '',
          end_date: '',
          untill_further_notice: false,
          alert_desccription: ''
        },
        is_edit: false,

      })
      this.props.getFieldAlert(
        {
          field_office__uuid: this.props.history.location.state.query.data.uuid,
          limit: 10,
          offset: 0
        });
    }
    if (Object.keys(props.NewFieldAlert.errors).length > 0 && props.NewFieldAlert.errors !== this.props.NewFieldAlert.errors) {
      errorHandle(props?.NewFieldAlert?.errors)
      this.setState({
        loader: false,
      })
    }

    if (Object.keys(props.FieldAlertsGet.data).length > 0 && props.FieldAlertsGet.data !== this.props.FieldAlertsGet.data) {
      alert_pagination.total = props.FieldAlertsGet.data.count
      this.setState({
        alert_pagination,
        loader: false,
        all_alerts: props.FieldAlertsGet.data.results
      })
    }
    if (Object.keys(props.FieldAlertsGet.errors).length > 0 && props.FieldAlertsGet.errors !== this.props.FieldAlertsGet.errors) {
      errorHandle(props?.FieldAlertsGet?.errors)
      this.setState({
        loader: false,
      })
    }

    //Update Franchise Office
    if (Object.keys(props.UpdateAlert.data).length > 0 && props.UpdateAlert.data !== this.props.UpdateAlert.data) {
      this.setState({
        loader: false,
        new_alert: {
          alert_type: '',
          start_date: '',
          end_date: '',
          untill_further_notice: false,
          alert_desccription: ''
        },
        is_edit: false
      })
      this.props.getFieldAlert(
        {
          field_office__uuid: this.props.history.location.state.query.data.uuid,
          limit: 10,
          offset: 0
        }
      );
    }
    if (Object.keys(props.UpdateAlert.errors).length > 0 && props.UpdateAlert.errors !== this.props.UpdateAlert.errors) {
      errorHandle(props?.UpdateAlert?.errors)
      this.setState({
        loader: false,
      })
    }
  }

  // Show Table Nav
  ShowNav = (record,) => {
    if (!this.state.openNav) {
      // attach/remove event handler
      document.addEventListener('click', this.handleOutsideClick, false);
    } else {
      document.removeEventListener('click', this.handleOutsideClick, false);
    }
    this.setState(prevState => ({
      openNav: !prevState.openNav,
      isNav: record.uuid
    }));
  }

  // hide list toggle button
  handleOutsideClick = (e) => {
    // ignore clicks on the Component itself
    if (this.node && this.node.contains(e.target)) {
      return;
    }
    this.ShowNav({ 'uuid': '' }, '');
  }

  //Add New Alert
  addNewAlert = () => {
    let { new_alert, field_office_uuid } = this.state;
    this.setState({
      loader: true
    })
    if (new_alert.untill_further_notice) {
      new_alert.end_date = null
    }
    let data = { ...new_alert, field_office_uuid }
    this.props.addFieldAlert(data);
  }

  //Update Alert
  updateAlert = () => {
    let { new_alert, field_office_uuid } = this.state;
    this.setState({
      loader: true
    })
    if (new_alert.untill_further_notice) {
      new_alert.end_date = null
    }
    let data = { ...new_alert, field_office_uuid }
    this.props.updateFieldAlert(data);
  }

  // validattion
  ValidateAlert = () => {
    let self = this;
    setTimeout(() => {
      let { new_alert } = this.state;
      const FranchiseSchema = yup.object().shape({
        new_alert: yup.object().shape({
          alert_type: yup.string().required("alert_type is required"),
          start_date: yup.string().required("Start Date is required"),
          end_date: yup.string().when('untill_further_notice', {
            is: false,
            then: yup.string().required('End Date is required'),
          }),
          alert_desccription: yup.string().required("Alert Desccription is required"),
        }),
      })
      const FranchiseData = {
        new_alert
      }

      let IsValid;
      FranchiseSchema.isValid(FranchiseData)
        .then(function (valid) {
          IsValid = valid
        });
      setTimeout(() => {
        if (IsValid) {
          self.setState({
            is_add_user_Active: true
          })
        }
        else {
          FranchiseSchema.validate(FranchiseData, { abortEarly: false })
            .catch(function (e) {
              console.log(e.errors)
              self.setState({
                is_add_user_Active: false
              })
            });
        }
      }, 100);
    }, 300);
  }

  //Table Pagination and Ordering
  onAlertHandelChange = (pagination) => {
    let { alert_pagination } = this.state;
    alert_pagination = Object.assign(alert_pagination, { 'current': pagination.current });

    let data = {
      field_office__uuid: this.props.history.location.state.query.data.uuid,
      offset: (pagination.current * 10) - 10,
      limit: 10,
    }

    this.props.getFieldAlert(data);

    this.setState({
      alert_pagination,
      loader: true
    })
  }

  //Render Alert Table
  renderAlertTable = () => {
    let { all_alerts, alert_pagination } = this.state;
    return (
      <Table
        rowKey={record => record.uuid}
        dataSource={all_alerts}
        pagination={alert_pagination}
        onChange={this.onAlertHandelChange}
        columns={DataTable.FranchiseAlerts(this)}
        className="table"
      />
    )
  }


  render() {
    let { new_alert, loader, alerts, is_add_user_Active, is_edit } = this.state;
    return (
      <div className="initial_cleaning_wrapper">
        <div className="calendar_wrapper">
          {this.renderAlertTable()}
        </div>
        <div className="form_wrapper">
          <div className="card">
            <div className="card-body">
              <div className="form-group">
                <h5>Add Franchise Alert</h5>
                <div className="fitem">
                  <label>Alert Type</label>
                  <Select
                    onChange={(e) => {
                      new_alert = Object.assign(new_alert, { alert_type: e });
                      this.setState({
                        new_alert
                      }, () => { this.ValidateAlert() })
                    }}
                    value={new_alert.alert_type || undefined}
                    placeholder={'Title'}
                  >
                    {map(alerts, (item) => {
                      return (
                        <Option key={item.key}>{item.value}</Option>
                      )
                    })}
                  </Select>

                </div>
                <div className="fitem">
                  <label>Start Date</label>
                  <DatePicker
                    style={{ 'width': '100%' }}
                    placeholder="Start Date"
                    name='start_date'
                    format="MM/DD/YYYY"
                    disabledDate={current => {
                      return current && current < moment().add(-1, "day");
                    }}
                    suffixIcon={<i className="las la-calendar"></i>}
                    allowClear={false}
                    onChange={(e) => {
                      new_alert = Object.assign(new_alert, { 'start_date': moment(e).format('YYYY-MM-DD') });
                      this.setState({
                        new_alert
                      }, () => { this.ValidateAlert() })
                    }}
                    value={new_alert.start_date ? moment(new_alert.start_date) : null}
                  />
                </div>
                <div className="fitem">
                  <div className="inline-check-list gcheck">
                    <div className="fitem-check mt-10">

                      <input
                        type="checkbox"
                        className="fitem-ck-input"
                        checked={new_alert.untill_further_notice}
                        id='untill_further_notice'
                        onChange={(e) => {
                          new_alert = Object.assign(new_alert, { untill_further_notice: e.target.checked, end_date: '' });

                          this.setState({
                            new_alert
                          }, () => { this.ValidateAlert() })
                        }}
                        name="checkboxsa" />
                      <label htmlFor='untill_further_notice' className="fitem-ck-txt">Until Further Notice</label>
                    </div>
                  </div>
                </div>
                <div className="fitem">
                  <label>End Date</label>
                  <DatePicker
                    placeholder="End Date"
                    disabled={new_alert.untill_further_notice}
                    style={{ 'width': '100%' }}
                    name='end_date'
                    format="MM/DD/YYYY"
                    disabledDate={current => {
                      if (new_alert.start_date) {
                        return current && current < moment(new_alert.start_date);
                      }
                      else {
                        return current && current < moment();
                      }
                    }}
                    suffixIcon={<i className="las la-calendar"></i>}
                    allowClear={false}
                    onChange={(e) => {
                      new_alert = Object.assign(new_alert, { 'end_date': moment(e).format('YYYY-MM-DD') });
                      this.setState({
                        new_alert
                      }, () => { this.ValidateAlert() })
                    }}
                    value={new_alert.end_date ? moment(new_alert.end_date) : null}
                  />
                </div>

                <div className="fitem">
                  <label>Alert Description</label>
                  <textarea
                    placeholder="Alert  Description"
                    value={new_alert.alert_desccription}
                    onChange={(e) => {
                      new_alert = Object.assign(new_alert, { alert_desccription: e.target.value });
                      this.setState({
                        new_alert
                      }, () => { this.ValidateAlert() })
                    }}

                  ></textarea>
                </div>
                <div>
                  <button
                    onClick={() => {
                      this.setState({
                        new_alert: {
                          alert_type: '',
                          start_date: '',
                          end_date: '',
                          untill_further_notice: false,
                          alert_desccription: ''
                        },
                        is_add_user_Active: false,
                        is_edit: false
                      })
                    }}
                    className="btn btn-bdr">Cancel </button>
                  {is_edit ?
                    <button
                      disabled={!is_add_user_Active}
                      className={!is_add_user_Active ? 'btn disabled' : 'btn btn-warning'}
                      onClick={() => { this.updateAlert() }}>Update  </button>
                    :
                    <button
                      disabled={!is_add_user_Active}
                      className={!is_add_user_Active ? 'btn disabled' : 'btn btn-warning'}
                      onClick={() => { this.addNewAlert() }}>Add  </button>}
                </div>
              </div>
            </div>
          </div>
        </div>
        {loader ? <Loader /> : ''}
      </div>
    );
  }
}

export default FranchiseAlerts;